export default __webpack_public_path__ + "static/media/active_dashboard_ico.e7aeb51e.svg";